import React from 'react';
import {ExpandBoxIcon, Icon, Rotate90Icon, Theme} from '@taopix/taopix-design-system';
import {useTranslation} from 'react-i18next';
import classNames from 'classnames';
import useViewportState from '../../Hooks/useViewportState';
import {ViewportState} from '@taopix/taopix-core';

const SmallScreenOrientationWarning = () => {
  const viewportState = useViewportState();
  const {t} = useTranslation();

  const overlayClasses = classNames(
    'w-full',
    'h-full',
    'fixed',
    'z-[10000]',
    'flex-col',
    'items-center',
    'justify-center',
    'flex'
  );

  const messageClasses = classNames(
    'flex-col',
    'w-[300px]',
    'space-y-sm',
    'text-center',
    'items-center',
    'flex'
  );

  if (viewportState === ViewportState.Normal) {
    return null;
  }

  return (
    <Theme
      id={'unsupportedScreenSizeOverlay'}
      name={'tpx-theme-main'}
      allowBorder={false}
      allowCorners={false}
      className={overlayClasses}
    >
      {viewportState === ViewportState.RequiresRotate ? (
        <div className={messageClasses}>
          <Icon icon={<Rotate90Icon />} size={'large'} />
          <p>{t('str_MessageMobileRotateDevice')}</p>
        </div>
      ) : (
        <div className={messageClasses}>
          <Icon icon={<ExpandBoxIcon />} size={'large'} />
          <p>{t('str_MessageIncreaseBrowserWindowSize')}</p>
        </div>
      )}
    </Theme>
  );
};

export default SmallScreenOrientationWarning;
